<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CreateEditPage
  Reason: CRUD component template for creating and editing SmSigningProcessSigner entities with parent context.
-->
@if (objectId) {
    <!-- AI: CRUD Object Component for SmSigningProcessSigner editing -->
    <mvs-crud-object
        [objectType]="objectType"
        [objectId]="objectId"
        (onChangedObject)="handleChanged($event)"
        (onFormDirty)="onFormDirty($event)">
    </mvs-crud-object>
} @else {
    <!-- AI: CRUD Object Component for SmSigningProcessSigner creation with parent context -->
    <mvs-crud-object
        [objectType]="objectType"
        [importObjectContextDto]="parentContext"
        (onChangedObject)="handleChanged($event)"
        (onFormDirty)="onFormDirty($event)">
    </mvs-crud-object>
}
